import { registerCondition } from "../conditionRegisterer.mjs";
export var CONDITION_NAME = 'true';
/**
 * @returns {boolean}
 */

export function condition() {
  return true;
}
registerCondition(CONDITION_NAME, condition, {
  name: 'True'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_handsontable@8.4.0@handsontable/plugins/filters/condition/true.mjs
// module id = null
// module chunks = 